module.exports = "/_next/static/images/healthier-choice-illustration-346eec8b9c3c01b4b92f02afe5084f61.svg";